/** Lazy-loaded department hero images (only the current page's image is fetched). */
const departmentHeroLoaders = {
  Cardiology: () => import('../assets/heroimages/Cardiology-department-hero.webp'),
  Neurology: () => import('../assets/heroimages/Neurology-department-hero.webp'),
  Pediatrics: () => import('../assets/heroimages/Pediatrics department-hero.webp'),
  'Internal Medicine': () => import('../assets/heroimages/internal-medicine-department-hero.webp'),
  Dermatology: () => import('../assets/heroimages/Dermatology-department-hero.webp'),
  Endocrinology: () => import('../assets/heroimages/Endocrinology-department-hero.webp'),
  Gastroenterology: () => import('../assets/heroimages/Gastroenterology-department-hero.webp'),
  Pulmonology: () => import('../assets/heroimages/Pulmonology-department-hero.webp'),
  Oncology: () => import('../assets/heroimages/Oncology-department-hero.webp'),
  Psychiatry: () => import('../assets/heroimages/Psychiatry-department-hero.webp'),
  'Emergency Medicine': () => import('../assets/heroimages/Cardiology-department-hero.webp'),
  'General Surgery': () => import('../assets/heroimages/pathology-department-hero.webp'),
  'Cardiac Surgery': () => import('../assets/heroimages/pathology-department-hero.webp'),
  'Orthopedic Surgery': () => import('../assets/heroimages/pathology-department-hero.webp'),
  Neurosurgery: () => import('../assets/heroimages/pathology-department-hero.webp'),
  'Obstetrics & Gynecology': () => import('../assets/heroimages/pathology-department-hero.webp'),
  Ophthalmology: () => import('../assets/heroimages/pathology-department-hero.webp'),
  'ENT Surgery': () => import('../assets/heroimages/pathology-department-hero.webp'),
  Urology: () => import('../assets/heroimages/pathology-department-hero.webp'),
  Laboratory: () => import('../assets/heroimages/pathology-department-hero.webp'),
  Radiology: () => import('../assets/heroimages/pathology-department-hero.webp'),
  Pathology: () => import('../assets/heroimages/pathology-department-hero.webp'),
  'Nuclear Medicine': () => import('../assets/heroimages/pathology-department-hero.webp'),
  'Critical Care': () => import('../assets/heroimages/pathology-department-hero.webp'),
};

export async function loadDepartmentHeroImage(departmentName) {
  const loader =
    departmentHeroLoaders[departmentName] ||
    departmentHeroLoaders.Cardiology;
  const mod = await loader();
  return mod.default;
}
